let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2lJZz")).then(() => parcelRequire('6LaWj'));